module.exports = __webpack_public_path__ + "img/p11.4c84c020.png";